require('./newCardDetails.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { findElementbyId } = require('routes/contractsView/utilities/contractStateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @components
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const UserAddress = require('../userAddress/userAddress');
const OKTag = require('components/commons/OKTag/OKTag');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @constants
const { getTranslatedCountry, COUNTRIES_CODES: { NL } } = require('constants/countries');
const {
    ACCOUNT_INTERVENTION_OWNER_CODE,
    ACCOUNT_INTERVENTION_REPRESENTATIVE_CODE,
    ACCOUNT_INTERVENTION_AUTHORIZED_CODE,
    ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE,
    EURO_SYMBOL,
} = require('constants/index');

const INTERVENER_TITLE = {
    '01': 'contractsView-intervenerTitular',
    '07': 'contractsView-intervenerRepresentative',
    '08': 'contractsView-intervenerAuthorized',
    '09': 'contractsView-intervenerLegalRepresentative'
};

const INTERVENER_NUMBER_BY_NAME = {
    'TITULAR': ACCOUNT_INTERVENTION_OWNER_CODE,
    'REPRESENTANTE': ACCOUNT_INTERVENTION_REPRESENTATIVE_CODE,
    'AUTORIZADO': ACCOUNT_INTERVENTION_AUTHORIZED_CODE,
    'APODERADO': ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE,
    'REPRESENTANTE LEGAL': ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE,
};
const classnames = require('classnames');

class NewCardDetails extends React.Component {

    UNSAFE_componentWillMount() {
        const { immProfileFields, addSimpleIntervener, clearInterveners, showCurrentUser } = this.props;
        // Reset the card details values
        clearInterveners();
        if (immProfileFields.get('nombreCliente') && showCurrentUser) {
            addSimpleIntervener(immProfileFields.get('nombreCliente') + immProfileFields.getIn(['apellidoUno', 'apellido']) + immProfileFields.getIn(['apellidoDos','apellido']), '01', immProfileFields.getIn(['documentoIdentificacion','codigodocumpersonacorp']));
        }
    }

    buildFields(visibleStep) {
        return this.flatCardDetails(visibleStep).map((item, index) => {
            const { immProfileFields, wizardState, originCountry } = this.props;
            const promotionalCode = wizardState.get('promotionalCode');
            const itemValue = item.get('value');
            const itemLabel = item.get('label');
            const itemDecimalsLength = item.get('decimalsLength');
            const itemFormat = item.get('format_type');

            switch (item.get('type')) {
                case 'single':
                    let value;
                    let detailsValue;
                    let creditLimit;

                    // We don't want to check for '0' values.

                    if (itemValue === null) {
                        value = this.buildPendingMessage();
                    } else {
                        if (item.get('formatNumber')) {
                            const amountObj = {
                                currency: itemFormat,
                                amount: itemValue,
                                decimalsLength: itemDecimalsLength
                            };
                            const plainAmountObject = getPlainAmountObject(amountObj);
                            const formatObject = formatAmountObject(plainAmountObject, true)
                            let currencySymbol = null

                            if (NL === originCountry && item.get('format_type') === EURO_SYMBOL) {
                                currencySymbol = `${formatObject.currencySymbol} `
                                formatObject.currencySymbol = ''
                            }

                            detailsValue = (<OneLineSymbolAmount
                                modifier={currencySymbol}
                                amountObject={plainAmountObject}
                                language={getLanguage()}
                                amountObjectFormatted={formatObject} />);
                            creditLimit = item.get('notImportantValue') ? false: true;
                        } else {
                            creditLimit = false;
                            if (itemFormat) {
                                detailsValue = `${itemValue} ${itemFormat}`;
                            } else {
                                detailsValue =  itemValue;
                            }
                            /**
                             * If we have the property isLanguageString that
                             * means we have a code to use a copy inside a
                             * FormattedText component.
                             */

                            if (item.get('isLanguageString')) {
                                detailsValue = item.get('injectedStringValues')
                                    ? <FormattedText value={itemValue} injectedStrings={item.get('injectedStringValues').toJS()}/>
                                    : <FormattedText value={itemValue} />;
                            }
                        }

                        const classNameNew = classnames(
                            'new-card-details__value',
                            {
                                ['new-card-details__important-value']: creditLimit
                            }
                        );

                        const valueString = (item.get('id') === 'cta_seleccionada')
                            ? item.get('description')
                            : detailsValue;
                        value = (
                            <span className={classNameNew}>
                                {valueString}
                            </span>
                        );
                    }
                    return (
                        <div className="new-card-details__field" key={itemLabel.toString()}>
                            <FormattedText value={itemLabel} className="new-card-details__label" />
                            {value}
                        </div>
                    );
                case 'array':
                    const fields = !itemValue ? this.buildPendingMessage() :
                        itemValue.map( field => (
                            <div className="new-card-details__box" key={field.get('name').toString()}>
                                <span className="new-card-details__type">
                                    {field.get('type')}
                                </span>
                                <span className="new-card-details__multiple">
                                    {field.get('name')}
                                </span>
                            </div>
                        ));

                    return (
                        <div className="new-card-details__field" key={itemLabel.toString()}>
                            <FormattedText value={itemLabel} />
                            {fields}
                        </div>
                    );
                case 'address':
                    return (
                        <section className="new-card-details__field" key={index.toString()}>
                            <FormattedText value={itemLabel} className="new-card-details__label" />
                            <div className="new-card-details__value">
                                <UserAddress immProfileFields={immProfileFields} modifier="new-card-details"/>
                            </div>
                        </section>
                    );
                case 'nacionality':
                    return (
                        <section className="new-card-details__field" key={index.toString()}>
                            <FormattedText value={itemLabel} className="new-card-details__label" />
                            <div className="new-card-details__value">
                                <p>{getTranslatedCountry(immProfileFields.get('paisNacionalidad'))}</p>
                            </div>
                        </section>
                    );
                case 'countryOfResidence':
                    return (
                        <section className="new-card-details__field" key={index.toString()}>
                            <FormattedText value={itemLabel} className="new-card-details__label" />
                            <div className="new-card-details__value">
                                <p>{getTranslatedCountry(immProfileFields.get('paisResidencia'))}</p>
                            </div>
                        </section>
                    );
                case 'separator':
                    return <div key={index.toString()} className="new-card-details__separator"></div>;
                case 'interveners':
                    const interveners = this.buildInterveners();
                    return (
                        <section className="new-card-details__field" key={index.toString()}>
                            <FormattedText value="contractsView-interveners" className="new-card-details__interveners-title" />
                            {interveners}
                        </section>
                    );
                case 'promotion':
                    let promotionTitle;
                    let promotionCode;
                    let promotionalCodeSubTitle;

                    if (promotionalCode) {
                        promotionTitle = <div className="new-card-details__promotion-title">{promotionalCode.get('title')}</div>;
                        promotionCode = <div className="new-card-details__label">{promotionalCode.get('code')}</div>;
                        promotionalCodeSubTitle = <div className="new-card-details__value">{promotionalCode.get('subTitle')}</div>;
                    }

                    return (
                        <section className="new-card-details__field" key={index.toString()}>
                            {promotionTitle}
                            {promotionCode}
                            {promotionalCodeSubTitle}
                        </section>
                    );
                default:
                    break;
            }
        });
    }

    buildIntervenerGroup (immGroup, hasJunior = false) {
        let type = hasJunior ? ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE : immGroup.first().get('typeNumber');
        if (!type) {
            type = INTERVENER_NUMBER_BY_NAME[immGroup.first().get('type')]
        }
        const interveners = immGroup.map(immIntervener => (
            <div className="new-card-details__value" key={immIntervener.get('name').toString()}>
                {immIntervener.get('name')}
            </div>
        ));

        const title = INTERVENER_TITLE[type];
        return (
            <div className="new-card-details__field">
                <FormattedText value={title} />
                {interveners}
            </div>
        );
    }

    buildInterveners () {
        const { wizardState } = this.props;
        const immInterveners = wizardState.get('interveners');
        let content, juniorTitular;
        if (immInterveners.size) {
            const juniorPersonalData = findElementbyId(wizardState.get('card_details'), 'junior_form_personal_data');
            const hasJunior = !!juniorPersonalData;
            if (hasJunior) {
                const juniorName = findElementbyId(juniorPersonalData, 'input-safe-name');
                const lastName = findElementbyId(juniorPersonalData, 'input-safe-last-name');
                const secondLastName = findElementbyId(juniorPersonalData, 'input-safe-second-last-name');
                const titularName = `${juniorName} ${lastName} ${secondLastName || ''}`;
                juniorTitular = (
                    <div className="new-card-details__field">
                        <FormattedText value={'contractsView-intervenerTitular'} />
                        <div className="new-card-details__value">
                            {titularName}
                        </div>
                    </div>
                );
            }
            content = immInterveners.groupBy(immIntervener => {
                const type = immIntervener.get('typeNumber') ? immIntervener.get('typeNumber') : INTERVENER_NUMBER_BY_NAME[immIntervener.get('type')];
                return hasJunior ? ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE : type
            }
            ) //This currently works only for Depositos/Open Young/E-Cuenta
            .map(immIntervenerGroup => this.buildIntervenerGroup(immIntervenerGroup, hasJunior)).toArray();
        } else {
            content = this.buildPendingMessage();
        }
        return (
            <div>
                {juniorTitular}
                {content}
            </div>
        );
    }

    buildPendingMessage() {
        return (
            <div className="new-card-details__pending-step">
                <FormattedText value="contractsView-toDefine" />
            </div>
        );
    }

    flatCardDetails(visibleStep) {
        const { wizardState, immFlagBasedFeatures } = this.props;
        const cardDetails = wizardState.get('card_details') || [];
        let ret = [];

        cardDetails.forEach(detail => {
            let showDetail = true

            detail.get('featureFlags') && detail.get('featureFlags').forEach(flag => {
                if (!immFlagBasedFeatures.get(flag) && showDetail) {
                    showDetail = false
                }
            })

            if (showDetail) {
                detail.get('visible') && detail.get('visible').forEach(visibleDetail => {
                    if (visibleDetail.get('step') === visibleStep) {
                        let tempItem = detail;

                        tempItem = tempItem.withMutations( map => {
                            map.set('order', visibleDetail.get('order'));
                        });

                        ret.push(tempItem);
                    }
                });
            }
        });

        return ret.sort((a, b) => a.get('order') - b.get('order'));
    }

    loadCollectiveContent() {
        const { immProfileFields, localState } = this.props;
        let content;
        if (localState.checkUserIsCollective && immProfileFields.get('isCollective')) {
            content = (
                <div className="pull-right">
                    <OKTag content="colectivos-businessTag" type="identification" />
                    <OKTooltip
                        content="contractSummary-collectiveTooltipContent"
                        placement="bottom"
                        offset={[0, 15]}
                    />
                </div>
            );
        }
        return content;
    }

    buildCardImageContainer() {
        const {
            immCommercialAds,
            immHireCardImageSelector,
            wizardState,
        } = this.props;
        const cardDetails = wizardState.get('card_details');
        const contractsWithNewCardImgComponent = [
            'checking-account',
            'payroll-account',
        ];
        const immCardImg = !!cardDetails ? cardDetails.find(x => x.get('id') === 'card_image') : null;
        const selectedCard = !!immCardImg && immCardImg.get('value');
        let cardImageContainer;
        if (!!selectedCard) {
            if (contractsWithNewCardImgComponent.includes(wizardState.get('name_contract'))) {
                if (immHireCardImageSelector.get('fetchSuccess')) {
                    const immImage = immHireCardImageSelector.getIn(['imagesById', selectedCard]);

                    if (!!immImage) {
                        cardImageContainer = (
                            <div className="new-card-details__image-container">
                                <img
                                    className="new-card-details__image"
                                    src={immImage.get('url')}
                                />
                            </div>
                        );
                    }
                }
            } else if (wizardState.get('visibleStep') !== 1) {
                const imgSrc = immCommercialAds.getIn(['byId', selectedCard, 'fieldImageMedium', 'url']);
                const extraImage = immCardImg.get('extraImage');
                let extraImageElement;
                if (extraImage) {
                    const extraImageSrc = immCommercialAds.getIn(['byId', extraImage, 'fieldImageMedium', 'url']);
                    extraImageElement = (
                        <div className="new-card-details__extra-image-container">
                            <img
                                src={extraImageSrc}
                                className="new-card-details__extra-image"
                            />
                        </div>
                    );
                }

                cardImageContainer = (
                    <div className="new-card-details__image-container">
                        {extraImageElement}
                        <img
                            className="new-card-details__image"
                            src={imgSrc}
                        />
                    </div>
                );
            }
        }

        return cardImageContainer;
    }

    render() {
        const {
            localState,
            wizardState,
        } = this.props;
        const fields = this.buildFields(wizardState.get('visibleStep'));
        const cardDetailsTitle = localState.card_details_title;
        const collectiveContent = this.loadCollectiveContent();
        const cardImageContainer = this.buildCardImageContainer();

        return (
            <OKSectionBox className="new-card-details">
                <section>
                    {cardImageContainer}
                    <h3 className="new-card-details__title">
                        <FormattedText value={cardDetailsTitle} />
                        {collectiveContent}
                    </h3>
                    {fields}
                </section>
            </OKSectionBox>
        );
    }
}

NewCardDetails.defaultProps = {
    notImportantValue: false,
    showPromotionSummary: false
};

NewCardDetails.propTypes = {
    addSimpleIntervener: PropTypes.func,
    clearInterveners: PropTypes.func,
    immCommercialAds: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    localState: PropTypes.object.isRequired,
    notImportantValue: PropTypes.bool,
    showCurrentUser: PropTypes.bool,
    wizardState: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    originCountry: PropTypes.string.isRequired,
}

module.exports = NewCardDetails;
